import React, { useRef, useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Typography, Box } from '@mui/material'
import AdxStatusBar from 'components/reusable/statusBar/AdxStatusBar'
import { format, parseISO } from 'date-fns'

export const LeaveBalanceCardReplacement = ({ item, inDrawer, selectLeave, isSelected, list }) => {
  const selectedRef = useRef(null)
  const [selectedHeight, setSelectedHeight] = useState(0)
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (selectedRef && !selectedHeight) {
      setSelectedHeight(selectedRef.current.clientHeight)
    }
  }, [selectedRef, selectedHeight])

  return (
    <Box
      ref={selectedRef}
      onClick={
        inDrawer
          ? () => selectLeave()
          : () =>
              navigate(`/app/leave/request/balance`, {
                state: {
                  backgroundLocation: location,
                  list: list,
                  initialSelected: {
                    type: 'leave_credit',
                    index: 0,
                    detail: 'REPLACEMENT',
                  },
                },
              })
      }
      sx={{
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        columnGap: 2,
        backgroundColor: isSelected && 'alternate.light',
        borderRadius: isSelected && 1,
        pl: inDrawer && !isSelected && 3.25,
        pr: inDrawer && 1,
        height: '55px',
      }}
    >
      {isSelected && (
        <Box
          width="3px"
          height={`${selectedHeight}px`}
          mr={1}
          sx={{ backgroundColor: 'alternate.main' }}
        />
      )}
      <Typography py={inDrawer ? 2 : 1} flex={1} variant="subtitle1" color="dark-text.main">
        Replacement Credit
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 2 }}>
        {item?.leave_credit_expiry && (
          <AdxStatusBar
            status={{
              text: inDrawer
                ? item?.leave_credit_expiry[0]?.expiry_date
                  ? `${item?.leave_credit_expiry[0]?.granted} expiring on ${format(
                      parseISO(item?.leave_credit_expiry[0]?.expiry_date),
                      'dd MMM'
                    )}`
                  : 'No expiry'
                : item?.leave_credit_expiry[0]?.expiry_date
                ? `${item?.leave_credit_expiry[0]?.granted} expiring on ${format(
                    parseISO(item?.leave_credit_expiry[0]?.expiry_date),
                    'dd MMM'
                  )}`
                : 'No expiry',
              color: 'yellow-02.main',
              bgColor: 'light-yellow-01.main',
            }}
          />
        )}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="subtitle1" color="alternate.main" sx={{ fontWeight: 'bold' }}>
            {item?.leave_credit?.amount ? item?.leave_credit?.balance : null}
          </Typography>
          <Typography variant="subtitle1" color="light-gray-text.main">
            {item?.leave_credit?.amount ? ` /${item?.leave_credit?.amount}` : 'None'}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

const LeaveBalanceCardList = ({ item, index, isSelected, inDrawer, selectLeave, list }) => {
  const selectedRef = useRef(null)
  const [selectedHeight, setSelectedHeight] = useState(0)
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (selectedRef && !selectedHeight) {
      setSelectedHeight(selectedRef.current.clientHeight)
    }
  }, [selectedRef, selectedHeight])

  const grandEntitlementAmount =
    item?.entitlement?.amount + (item?.carry_forward ? item?.carry_forward?.amount : 0)

  const grandEntitlementUsed = item?.entitlement?.utilised + item?.entitlement?.outstanding

  return (
    <Box
      ref={selectedRef}
      onClick={
        inDrawer
          ? () => selectLeave(item.leave_policy.type, item.id)
          : () =>
              navigate(`/app/leave/request/balance`, {
                state: {
                  backgroundLocation: location,
                  list: list,
                  initialSelected: {
                    type: item.leave_policy.type === 1 ? 'with_entitlement' : 'without_entitlement',
                    index: index,
                    detail: item.leave_policy.type === 1 ? 'WITH' : 'WITHOUT',
                  },
                },
              })
      }
      sx={{
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        backgroundColor: isSelected && 'alternate.light',
        borderRadius: isSelected && 1,
        px: inDrawer && 1,
      }}
    >
      {isSelected && <Box width="3px" mr={1} sx={{ backgroundColor: 'alternate.main' }} />}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flex: 1,
          justifyContent: 'space-between',
          width: 1,
          py: 2,
        }}
      >
        <Typography variant="subtitle1" color="dark-text.main">
          {item?.leave_policy?.name}
        </Typography>
        {item?.entitlement ? (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="subtitle1" color="alternate.main" sx={{ fontWeight: 'bold' }}>
              {/* Balance */}
              {grandEntitlementAmount - grandEntitlementUsed !== null
                ? `${Number(grandEntitlementAmount - grandEntitlementUsed)} `
                : null}
            </Typography>
            <Typography variant="subtitle1" color="light-gray-text.main">
              {grandEntitlementAmount !== null ? `/${Number(grandEntitlementAmount)}` : null}
            </Typography>
          </Box>
        ) : (
          <Typography variant="subtitle1" color="light-gray-text.main">
            None
          </Typography>
        )}
      </Box>
    </Box>
  )
}

export default LeaveBalanceCardList
